<script>
export default {
    methods: {
        enableButton(button) {
            button.classList.remove('active');
            button.removeAttribute('disabled');
        },

        disableButton(button) {
            button.setAttribute('disabled', '');
        },
    },
};
</script>
